"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconTools = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M46.38 39.1l16.5-16.51a1.6 1.6 0 0 0 0-2.26l-8.16-8.16a1.6 1.6 0 0 0-2.26 0l-11 11-5.5 5.5-4.31-4.31 1.59-1.59a1.6 1.6 0 0 0 0-2.26L30 17.24a24.94 24.94 0 0 1 10.53-7.55 1.6 1.6 0 0 0 .18-2.93c-.37-.19-9.17-4.47-18.56 4.93L11.67 22.16l-.25-.25a1.65 1.65 0 0 0-2.26 0l-5.53 5.53a1.6 1.6 0 0 0 0 2.26l11.59 11.59a1.6 1.6 0 0 0 2.26 0L23 35.76a1.6 1.6 0 0 0 0-2.26l-.25-.25 1.93-1.93 4.32 4.3-5.7 5.7-10.8 10.8a1.6 1.6 0 0 0 0 2.26l8.16 8.16a1.6 1.6 0 0 0 2.26 0L39.42 46l16.47 16.51a1.6 1.6 0 0 0 2.26 0l4.69-4.69a1.6 1.6 0 0 0 0-2.26zm-3.79-12.54l3.12 3.12A1.6 1.6 0 1 0 48 27.42l-3.15-3.12 3.79-3.79 3.12 3.12A1.6 1.6 0 1 0 54 21.36l-3.1-3.12 2.68-2.68 5.9 5.9-15.37 15.37-5.9-5.9zM16.35 37.9L7 28.57l3.27-3.27.25.25 8.83 8.83.25.25zM20.5 31l-6.56-6.56 10.47-10.49c4-4 7.74-5 10.49-5.12a26.94 26.94 0 0 0-8.39 7.69 1.6 1.6 0 0 0 .21 2l3.13 3.13zm1.29 28.18l-5.9-5.9 2.49-2.49 3.12 3.12a1.6 1.6 0 0 0 2.26-2.26l-3.12-3.12 3.79-3.79 3.12 3.12a1.6 1.6 0 1 0 2.26-2.26l-3.12-3.12 4.57-4.57 5.9 5.9zm35.23 0L27 29.05l2.43-2.43 30.01 30.07z"
  })),
  height: undefined,
  width: undefined
});
IconTools.displayName = 'IconTools';
var _default = IconTools;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/tools.js
// module id = 592
// module chunks = 0